import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCodeAnalyze: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCodeAnalyze"><Path d="M13 3.5H3.5V20.5H20.5V11" stroke="currentColor"/><Path d="M7 8.5H13" stroke="currentColor" strokeLinejoin="round"/><Path d="M7 12H10.5" stroke="currentColor" strokeLinejoin="round"/><Path d="M12 12H17" stroke="currentColor" strokeLinejoin="round"/><Path d="M7 15.5H14" stroke="currentColor" strokeLinejoin="round"/><Path d="M19 1L20.0804 3.91964L23 5L20.0804 6.08036L19 9L17.9196 6.08036L15 5L17.9196 3.91964L19 1Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCodeAnalyze;
